const getSundaysForCurrentAndNextYear = (): string[] => {
    const sundays: string[] = [];
    const today = new Date();

    const currentYear = today.getFullYear();
    const nextYear = currentYear + 1;

    // Start from the first Sunday of the current year
    const date = new Date(currentYear, 0, 1);

    // Find the first Sunday of the year
    while (date.getDay() !== 0) {
        date.setDate(date.getDate() + 1);
    }

    // Collect all Sundays until the end of next year
    while (date.getFullYear() <= nextYear) {
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();

        sundays.push(`${day}/${month}/${year}`);

        // Move to the next Sunday
        date.setDate(date.getDate() + 7);
    }

    return sundays;
};

export default getSundaysForCurrentAndNextYear;
